import { Viewer } from "@inovitas/infra3dsdk";
import React from "react";

export const manageKeyboardEvents = (
  viewer: Viewer | undefined,
  state: boolean
) => {
  if (viewer) {
    if (state) {
      viewer.getScene().userInputHandler.disableKeyEvents();
      viewer.getComponent("keyboard").deactivate();
    } else {
      viewer.getScene().userInputHandler.enableKeyEvents();
      viewer.getComponent("keyboard").activate();
    }
  }
};
